<template>
  <el-dialog
    v-model="visible"
    :title="notification.title"
    width="500px"
    class="notification-detail-dialog"
    center
    destroy-on-close
    :append-to-body="true"
  >
    <div class="notification-detail-content">
      {{ notification.content }}
    </div>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  notification: {
    type: Object,
    required: true
  },
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible']);

// 侦听visible属性
const visible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});
</script>

<style scoped>
/* 确保详情弹窗居中显示并完整可见 */
:deep(.notification-detail-dialog) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.notification-detail-dialog .el-dialog) {
  margin: 15vh auto !important;
  position: relative !important;
  max-height: 70vh !important;
  display: flex !important;
  flex-direction: column !important;
}

:deep(.notification-detail-dialog .el-dialog__body) {
  padding: 20px !important;
  overflow-y: auto !important;
  max-height: 50vh !important;
}

.notification-detail-content {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  line-height: 1.6;
  white-space: pre-wrap;
}
</style> 